var _path, _path2, _path3, _path4, _path5, _path6, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg5Benefiticon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6667 29C38.6667 31.5773 36.5774 33.6666 34 33.6666C31.4227 33.6666 29.3334 31.5773 29.3334 29C29.3334 26.4227 31.4227 24.3333 34 24.3333C36.5774 24.3333 38.6667 26.4227 38.6667 29Z",
    fill: "#7957FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42 41C42 43.5773 38.4183 45.6666 34 45.6666C29.5817 45.6666 26 43.5773 26 41C26 38.4227 29.5817 36.3333 34 36.3333C38.4183 36.3333 42 38.4227 42 41Z",
    fill: "#7957FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.496 25.6667C27.7326 25.6667 27.9636 25.6899 28.1867 25.7341C27.6433 26.6993 27.3333 27.8135 27.3333 29C27.3333 30.1577 27.6284 31.2464 28.1474 32.1952C27.9366 32.2345 27.7188 32.255 27.496 32.255C25.6101 32.255 24.0813 30.7802 24.0813 28.9609C24.0813 27.1415 25.6101 25.6667 27.496 25.6667Z",
    fill: "#7957FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2631 44.3146C24.5059 43.4095 24 42.2987 24 41C24 39.741 24.4754 38.6587 25.1943 37.769C22.6548 37.966 20.6666 39.355 20.6666 41.0392C20.6666 42.7392 22.6897 44.1385 25.2631 44.3146Z",
    fill: "#7957FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6665 29C40.6665 30.1577 40.3714 31.2464 39.8524 32.1952C40.0632 32.2345 40.281 32.255 40.5038 32.255C42.3897 32.255 43.9185 30.7802 43.9185 28.9609C43.9185 27.1415 42.3897 25.6667 40.5038 25.6667C40.2672 25.6667 40.0362 25.6899 39.8131 25.7341C40.3565 26.6993 40.6665 27.8135 40.6665 29Z",
    fill: "#7957FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7367 44.3146C45.3101 44.1385 47.3332 42.7392 47.3332 41.0392C47.3332 39.355 45.3451 37.966 42.8055 37.769C43.5244 38.6587 43.9998 39.741 43.9998 41C43.9998 42.2987 43.494 43.4095 42.7367 44.3146Z",
    fill: "#7957FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5.5,
    width: 58,
    height: 58,
    rx: 15.5,
    stroke: "url(#paint0_linear_27_1862)",
    strokeOpacity: 0.3,
    strokeWidth: 11
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27_1862",
    x1: 34.5,
    y1: 0,
    x2: 34.5,
    y2: 69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5Benefiticon);
export default __webpack_public_path__ + "static/media/5 benefit icon.a5ec2ea7d0c12da0dcfda3ebb36b7ffb.svg";
export { ForwardRef as ReactComponent };